<!--The content below is only a placeholder and can be replaced.-->
<div class="app-container">
  <app-detect-network-state></app-detect-network-state>
  <router-outlet></router-outlet>
</div>
